// External ThirdEye learning portal (separate app/domain).
export const PORTAL_URL = 'https://3rdeye-reactweb.lts246.xyz';
export const PORTAL_LOGIN_URL = `${PORTAL_URL}/login`;
